import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Modal, Form, Card, Col, Row } from "react-bootstrap";
import RxnTable from "../layout/components/RxnTable";
import Select from "react-select";
import { IconDelete } from "../layout/components/SVGs";

export default function ManageBioisosteres() {
  //
  //USE STATES
  //
  const [syn, setSyn] = useState([]);
  const [tags, setTags] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rxnStates, setRxnStates] = useState([]);

  const [rxn, setRxn] = useState({
    replacement: "",
    smarts: "",
    refs: [],
    // group1: "",
    // group2: "",
    level: 0,
    size_change: "",
    logp_change: "",
    solubility_change: "",
    metabolic_stability: "",
    rigidity_change: "",
    sp3_bond_change: "",
    hba: "",
    hbd: "",
  });

  const change_types = [
    { label: "Increase", value: "increase" },
    { label: "Decrease", value: "decrease" },
    { label: "No Change", value: "same" },
    { label: "Similar", value: "similar" },
    { label: "Unknown", value: "unknown" },
  ];

  const changes = [
    "size_change",
    "logp_change",
    "solubility_change",
    "metabolic_stability",
    "rigidity_change",
    "sp3_bond_change",
    "hba",
    "hbd",
  ];

  const [rxnList, setRxnList] = useState({
    columns: [
      {
        label: "Replacement",
        field: "replacement",
      },
      {
        label: "Level (1-4)",
        field: "level",
      },
      {
        label: "Smarts",
        field: "smarts",
      },
      {
        label: "Mwt",
        field: "size_change",
      },
      {
        label: "LogP",
        field: "logp_change",
      },
      {
        label: "Solubility",
        field: "solubility_change",
      },
      {
        label: "Metabolic Stability",
        field: "metabolic_stability",
      },
      {
        label: "Rigidity",
        field: "rigidity_change",
      },
      {
        label: "Sp3 Bonds",
        field: "sp3_bond_change",
      },
      {
        label: "HBA",
        field: "hba",
      },
      {
        label: "HBD",
        field: "hbd",
      },
    ],
    data: [],
  });

  //
  //FUNCTIONS
  //

  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (row) => {
    getRxn(row.id);
    setShowEdit(true);
  };

  const handleCloseDelete = () => {
    setRxn({
      rxnName: "",
      rxnDescription: "",
      rxnSmarts: "",
      rxnSmartsDescription: "",
      rxnId: "",
      rxnState: "",
      rxnTags: [],
    });
    setShowDelete(false);
  };
  const handleShowDelete = (row) => {
    setRxn({
      rxnId: row.id,
      rxnName: row.replacement,
    });
    setShowDelete(true);
  };

  // Triggers every change in synthon form
  const synFormChange = (index, e) => {
    let data = [...syn];
    data[index][e.target.id] = e.target.value;
    setSyn(data);
  };

  // function getTagList() {
  //     axios({
  //         method: "GET",
  //         url: "/
  //     }).then((res) => {
  //         let getTagLabels = [];
  //         for (let i = 0; i < res.data.tags.length; i++) {
  //             getTagLabels.push({
  //                 label: res.data.tags[i].label,
  //                 value: res.data.tags[i].value,
  //             });
  //         }
  //         setTags(getTagLabels);
  //     });
  // }

  async function getReactions() {
    setLoading(true);
    await axios({
      method: "GET",
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token")}`,
      },
      url: "/admin/manage/bioisosteres_list",
    })
      .then((res) => {
        setRxnList({ ...rxnList, data: res.data });
      })
      .catch((err) => console.log(err));
    setLoading(false);
  }

  function getRxn(id) {
    axios({
      method: "GET",
      url: "/bioisostere/" + id,
    }).then((res) => {
      setRxn({
        ...rxn,
        id: res.data.id,
        replacement: res.data.replacement,
        smarts: res.data.smarts,
        refs: res.data.refs || [],
        level: res.data.level,
        // category: res.data.category,
        // group2: res.data.group2,
        size_change: res.data.size_change,
        logp_change: res.data.logp_change,
        solubility_change: res.data.solubility_change,
        metabolic_stability: res.data.metabolic_stability,
        rigidity_change: res.data.rigidity_change,
        sp3_bond_change: res.data.sp3_bond_change,
        hba: res.data.hba,
        hbd: res.data.hbd,
      });

      // let data = res.data.synthons;
      // let newSyn = [];
      // for (let index = 0; index < data.length; index++) {
      //     newSyn.push({
      //         synthon_name: data[index].synthon_name,
      //         synthon_id: data[index].synthon_id,
      //         synthon_inclusion_smarts: data[index].synthon_inclusion_smarts
      //             ? data[index].synthon_inclusion_smarts.join("\n")
      //             : "",
      //         synthon_exclusion_smarts: data[index].synthon_exclusion_smarts
      //             ? data[index].synthon_exclusion_smarts.join("\n")
      //             : "",
      //     });
      // }
      // setSyn(newSyn);
    });
  }
  function submitRxnUpdate() {
    let rxnData = {
      ...rxn,
    };
    console.log(rxnData);
    axios({
      method: "POST",
      url: "/admin/manage/bioisosteres/update",
      data: rxnData,
    })
      .then((res) => {
        getReactions();
        alert(res.data.msg);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleDelete() {
    axios({
      method: "POST",
      url: "/admin/manage/bioisosteres/delete",
      data: rxn.rxnId,
    })
      .then((res) => {
        getReactions();
        alert(res.data.msg);
        handleCloseEdit();
      })
      .catch((error) => {
        console.error("Error deleting reaction:", error);
        getReactions();
        handleCloseEdit();
      });
  }

  useEffect(() => {
    getReactions();
    //getTagList();
  }, []);

  return (
    <>
      <RxnTable
        striped
        bordered
        hover
        hasTags
        adminRxnCache
        tags={tags}
        data={rxnList}
        loading={loading}
        actions={{
          edit: true,
          editLogic: (row) => {
            handleShowEdit(row);
          },
          delete: true,
          deleteLogic: (row) => {
            handleShowDelete(row);
          },
        }}
      ></RxnTable>
      <Modal
        size="xl"
        backdrop="static"
        show={showEdit}
        onHide={handleCloseEdit}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h2">Reaction Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/*  */}
            {/*  */}
            {/* Reaction Form */}
            {/*  */}
            {/*  */}
            <Card>
              <Card.Header>
                <h3>{rxn.rxnId}</h3>
              </Card.Header>
              <Card.Body>
                <Form.Group controlId="replacement">
                  <Form.Label>Replacement</Form.Label>
                  <Form.Control
                    type="text"
                    value={rxn.replacement}
                    onChange={(e) => {
                      setRxn({ ...rxn, replacement: e.target.value });
                    }}
                  />
                </Form.Group>
                <Form.Group controlId="smarts">
                  <Form.Label>SMARTS</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={rxn.smarts}
                    onChange={(e) => {
                      setRxn({ ...rxn, smarts: e.target.value });
                    }}
                  />
                </Form.Group>

                {changes.map((change) => (
                  <Form.Group controlId={change}>
                    <Form.Label>{change.replace(/_/g, " ")}</Form.Label>
                    <Select
                      options={change_types}
                      isClearable
                      value={change_types.find(
                        (option) => option.value === rxn[change]
                      )}
                      onChange={(e) => {
                        setRxn({ ...rxn, [change]: e.value });
                      }}
                    ></Select>
                  </Form.Group>
                ))}
              </Card.Body>
            </Card>
            <br />

            {/*  */}
            {/*  */}
            {/* Synthon Form */}
            {/*  */}
            {/*  */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Col className="rightText">
            <Button variant="primary" type="submit" onClick={submitRxnUpdate}>
              Save
            </Button>
          </Col>
        </Modal.Footer>
      </Modal>
      <Modal
        size="xl"
        backdrop="static"
        show={showDelete}
        onHide={handleCloseDelete}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Reaction</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>
            Are you sure you want to delete <b>{rxn.rxnName}</b>?
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={loading}
            variant="danger"
            type="submit"
            onClick={() => handleDelete()}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
